import React, { useEffect, useState } from 'react';
import createAuthInterceptor from '../utils/authInterceptor'; // Correggi il percorso se necessario
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Card, CardMedia, CardContent, CardHeader } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem, Pagination } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { green } from '@mui/material/colors';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import useDeviceDetection from './useDeviceDetection';
import { enqueueSnackbar } from 'notistack';

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const { REACT_APP_API_ENDPOINT } = process.env;

function UserImagesDepositi() {
  const navigate = useNavigate();
  const device = useDeviceDetection();
  const axiosInstance = createAuthInterceptor(navigate); // Crei l'istanza qui
  const [campaigns, setCampaigns] = useState([]);
  const [campaignId, setCampaignId] = useState('');
  // Stato per le immagini e parametri di filtro
  const [images, setImages] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState('');   // ID campagna selezionata (string vuota = none)
  const [selectedUser, setSelectedUser] = useState('');           // ID utente selezionato (solo per admin, string vuota = none)
  const [page, setPage] = useState(1);                            // pagina corrente per paginazione
  const [totalPages, setTotalPages] = useState(1);                // numero totale di pagine disponibili
  

  

  const [index, setIndex] = useState(-1);

  const currentImage = images[index];
  const nextIndex = (index + 1) % images.length;
  const nextImage = images[nextIndex] || currentImage;
  const prevIndex = (index + images.length - 1) % images.length;
  const prevImage = images[prevIndex] || currentImage;

  const handleClick = (index, item) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);


     // Carica le campagne disponibili
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const res = await axios.get(`${REACT_APP_API_ENDPOINT}/api/campaigns`);
        setCampaigns(res.data);
        
      } catch (err) {
        console.error('Errore nel recupero campagne:', err);
        enqueueSnackbar('Errore nel caricamento delle campagne', { variant: 'error' });
      }
    };
    fetchCampaigns();
  }, []);

  // Carica le immagini dell’utente per la campagna selezionata
  useEffect(() => {
    const fetchImages = async () => {
      if (!campaignId) {
        setImages([]);
        return;
      }

      try {
        const res = await axiosInstance.get('/api/images/user-images', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          params: {
            campaignId,
            page,
            limit: 12
          },
        });

        setImages(res.data.images);
        setTotalPages(Math.ceil(res.data.total / 12));
      } catch (err) {
        console.error('Errore nel recupero immagini:', err);
        enqueueSnackbar('Errore nel recupero delle immagini', { variant: 'error' });
      }
    };
    fetchImages();
  }, [campaignId, page]);

/*   useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axiosInstance.get('api/images/user-images', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        setImages(response.data);
      } catch (error) {
        console.error('Errore nel recupero delle immagini:', error);
        enqueueSnackbar('Errore nel recupero delle immagini', { variant: 'error' });
      }
    };

    fetchImages(); // Chiamata alla funzione
  }, []); */
//  console.log(device)
  return (
   
    <Container>
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Le Tue Immagini
        </Typography>

        {/* Filtro Campagna */}
        {campaigns.length > 0 && (
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="campagna-label">Campagna</InputLabel>
              <Select
                labelId="campagna-label"
                value={campaignId}
                onChange={(e) => {
                  setCampaignId(e.target.value);
                  setPage(1);
                }}
                label="Campagna"
              >
                <MenuItem value="">
                  <em>-- Seleziona una campagna --</em>
                </MenuItem>
                {campaigns.map((camp) => (
                  <MenuItem key={camp._id} value={camp._id}>
                    {camp.denominazione}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}


{/* Lista Immagini */}
{!campaignId ? (
          <Typography variant="body1">Seleziona una campagna per vedere le immagini.</Typography>
        ) : images.length === 0 ? (
  <Typography variant="body1">
    Nessuna immagine disponibile per questa campagna.
  </Typography>
) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {images.map((image, index) => (
            <React.Fragment key={image._id}>
            <Card sx={{ maxWidth: 345 }}>
            {device === 'Mobile' ?
            <CardHeader
                avatar={
                  <LocationOnIcon  sx={{ color: green[500] }}/>
                }
                title={image.ufficioPt === "" ? image.depositoPt.recapito: image.ufficioPt.denominazione} 
                subheader={image.username}
              />
            :
            <CardHeader
                avatar={
                  <Avatar sx={{ bgcolor: green[500] }} aria-label="recipe">
                  <LocationOnIcon />
                  </Avatar>
                }
                title={image.ufficioPt === "" ? image.depositoPt.recapito: image.ufficioPt.denominazione} 
                subheader={image.username}
              />
            }
              <CardMedia
                component="img"
                height="140"
                image={`${REACT_APP_API_ENDPOINT}/api/${image.path}`}
                alt="Immagine"
                onClick={()=>handleClick(index)}
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                 {image.location}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                 {image.address}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                 {new Date(image.uploadDate).toLocaleString()}
                </Typography>
              </CardContent>
            </Card>
            </React.Fragment>
          ))}

          {!!currentImage && (
            /* @ts-ignore */
            <Lightbox
              mainSrc={`${REACT_APP_API_ENDPOINT}/api/${currentImage.path}`}
              imageTitle={currentImage.address}
              mainSrcThumbnail={currentImage.path}
              nextSrc={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
              nextSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
              prevSrc={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
              prevSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
              onCloseRequest={handleClose}
              onMovePrevRequest={handleMovePrev}
              onMoveNextRequest={handleMoveNext}
            />
          )}
    
        </Box>

      )}

    {/* Paginazione */}
    {campaignId && totalPages > 1 && (
          <Box mt={4} pb={8}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, val) => setPage(val)}
              color="primary"
            />
          </Box>
        )}

      </Box>
    </Container>
  );
}

export default UserImagesDepositi;
